module.exports = __webpack_public_path__ + "static/media/background-pink.04af114a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-pink.png
// module id = 1008
// module chunks = 0